import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import OPEN_API_NAME from "@ext/markdown/elements/openApi/name";

const OpenApiFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	(state, node) => {
		state.write(
			formatter.openTag(
				OPEN_API_NAME,
				{
					src: node.attrs.src,
					// A spec that says nothing shows no schemas, so only showing them is worth saying.
					...(node.attrs.showSchemas === true || node.attrs.showSchemas === "true"
						? { showSchemas: "true" }
						: {}),
					...(node.attrs.showInfo === false ? { showInfo: "false" } : {}),
				},
				true,
			),
		);
		state.closeBlock(node);
	};

export default OpenApiFormatter;
